module.exports = __webpack_public_path__ + "img/dp-sy-zt4.c39754a1.png";